import { ButtonColor, CommonActionKey, SimpleDialogData } from "common";

export const reactivateSubmissionDialogData: SimpleDialogData = {
  body: "Reactivating will allow the submission to complete the underwriting process.",
  title: "Reactivate submission?",
  actions: [
    {
      label: "CANCEL",
      buttonColor: ButtonColor.Default,
      actionKey: CommonActionKey.Cancel,
    },
    {
      label: "CONFIRM",
      buttonColor: ButtonColor.Primary,
      actionKey: CommonActionKey.Confirm,
    }
  ]
}

export const markAsNotInterestedSuccessMessage = "Submission has been successfully marked as not interested.";
export const reactivateSubmissionSuccessMessage = "Submission has been successfully reactivated.";
export const actionErrorMessage = "There was an error while updating the submission status. Try again or contact your business advisor if the error keeps occurring.";
